/**
 * Nav Presenter
 */
class CartPresenter {

	constructor() {

		this.view = new CartView(this);
		this.cart = null;

		/*
		 * Listeners
		 */

		$(document).on(Model.CART_RETRIEVED, $.proxy(function(_event, cart) {
			// set the cart into the view
			this.cart = cart;
			this.view.setCart(this.cart);
			// check if we need to show the cart, and if we do make sure we reset the hash
			if (location.hash == "#shopping-cart-offcanvas") {
				this.view.showCart();
				location.hash = "";
			}
		}, this));

		$(document).on(Model.CART_QUANTITY_UPDATED, $.proxy(function(_event, cart) {
			// updating cart quantities triggers sending back the entire cart
			this.cart = cart;
			this.view.setCart(this.cart);
		}, this));

		$(document).on(Model.CART_UPDATED, $.proxy(function(_event, item) {
			// the easiest thing to do when a cart is updated, is just to pull the cart again
			$(document).trigger(Model.RETRIEVE_CART);
			// post a message that an item has been added to the cart
			var message = new Object();
			message.title = "Item Added to Cart";
			message.body = item.title;
			$(document).trigger(Model.POST_MESSAGE, [message]);
		}, this));

		/*
		 * Initialisation
		 */

		$(document).trigger(Model.RETRIEVE_CART);

	}

	/*
	 * Actions
	 */

	showingCart() {
		$(document).trigger(Model.SHOWING_CART);
	}

	updateItemQuantity(variantId, quantity) {
		var data = { "id": variantId, "quantity": quantity };
		$(document).trigger(Model.UPDATE_CART_QUANTITY, [data]);
	}

}